var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-mage content-430"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableData,"border":""},scopedSlots:_vm._u([{key:"operationType",fn:function(ref){
var row = ref.row;
return [_vm._v(" 运营平台 ")]}},{key:"action",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"ordinary-color-430",on:{"click":function($event){return _vm.handleToMage(row)}}},[_vm._v("管理")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }